import { Mail, Globe, ExternalLink } from "lucide-react";

/* @section: igc-logo-footer */
const IGCLogo = () => (
  <div className="flex items-center gap-3">
    <div
      style={{
        backgroundColor: "#fff",
        display: "inline-flex",
        alignItems: "center",
        padding: "7px 12px",
      }}
    >
      <span style={{ color: "#0B308E", fontFamily: '"Times New Roman", Times, serif', fontSize: "1.4rem", fontWeight: "normal", lineHeight: 1 }}>I</span>
      <span style={{ width: "1px", backgroundColor: "#0B308E", height: "1.1rem", margin: "0 8px", display: "block" }} />
      <span style={{ color: "#0B308E", fontFamily: '"Times New Roman", Times, serif', fontSize: "1.4rem", fontWeight: "normal", lineHeight: 1 }}>G</span>
      <span style={{ width: "1px", backgroundColor: "#0B308E", height: "1.1rem", margin: "0 8px", display: "block" }} />
      <span style={{ color: "#0B308E", fontFamily: '"Times New Roman", Times, serif', fontSize: "1.4rem", fontWeight: "normal", lineHeight: 1 }}>C</span>
    </div>
    <div className="flex flex-col leading-tight">
      <span className="font-semibold text-white text-sm tracking-widest uppercase">I-GROUP</span>
      <span className="text-white/60 text-[10px] tracking-wider uppercase">Islamic Finance consultants Group</span>
    </div>
  </div>
);

const services = [
  "Product Development",
  "Information Systems",
  "External Shariah Audit",
  "Training & Capacity Building",
  "Risk Management",
  "Compliance",
];

const quickLinks = ["About Us", "Services", "Why Choose Us", "Contact"];

/* @section: footer */
export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-primary text-white">
      {/* Gold divider */}
      <div style={{ height: "3px", background: "linear-gradient(90deg, transparent, #C9A84C, transparent)" }} />

      <div className="container mx-auto px-6 py-14 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <IGCLogo />
            <p className="mt-5 text-white/70 text-sm leading-relaxed">
              Specialized advisory firm delivering excellence in Islamic finance across product design, IT systems, Shariah audit, and professional training.
            </p>
            <div className="flex gap-3 mt-5">
              {[Globe, ExternalLink, Mail].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded border border-white/20 hover:border-accent hover:text-accent transition-colors"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase mb-5" style={{ color: "#C9A84C" }}>
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => scrollTo("services")}
                    className="text-white/70 hover:text-white text-sm transition-colors text-left"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase mb-5" style={{ color: "#C9A84C" }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l}>
                  <button
                    onClick={() => scrollTo(l.toLowerCase().replace(/ /g, "-").replace("choose-", ""))}
                    className="text-white/70 hover:text-white text-sm transition-colors text-left"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase mb-5" style={{ color: "#C9A84C" }}>
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-0.5 flex-shrink-0 text-accent" />
                <span>contact@oicgroup.org</span>
              </li>
              <li className="flex items-start gap-2">
                <Globe size={14} className="mt-0.5 flex-shrink-0 text-accent" />
                <span>www.oicgroup.org</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} I-GROUP — Islamic Finance consultants Group. All rights reserved.</span>
          <span>oicgroup.org</span>
        </div>
      </div>
    </footer>
  );
}
